import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';
import {
  OrganizationAddressBookPort,
  AddAddressBookEntryData,
  UpdateAddressBookEntryData,
  RemoveAddressBookEntryData
} from '../../domain/ports/OrganizationAddressBookPort';
import { RepositoryError } from '../../domain/errors';
import { ILoggerService } from '../../domain/services/LoggerService';

export class FirebaseOrganizationAddressBookAdapter implements OrganizationAddressBookPort {
  private readonly prefix = 'organizations';
  private readonly logger: ILoggerService;

  constructor(logger: ILoggerService) {
    this.logger = logger;
  }

  async addEntry(data: AddAddressBookEntryData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-addAddressBookEntry`;
    this.logger.logRepositoryRequest('OrganizationAddressBookAdapter', 'addEntry', { functionName, data });

    try {
      const fn = httpsCallable(functions, functionName);
      const result = await fn(data);

      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('OrganizationAddressBookAdapter', 'addEntry', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('OrganizationAddressBookAdapter', 'addEntry', duration, error);
      console.error('Add address book entry error:', error);

      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }

      throw RepositoryError.queryFailed();
    }
  }

  async updateEntry(data: UpdateAddressBookEntryData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-updateAddressBookEntry`;
    this.logger.logRepositoryRequest('OrganizationAddressBookAdapter', 'updateEntry', { functionName, data });

    try {
      const fn = httpsCallable(functions, functionName);
      const result = await fn(data);

      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('OrganizationAddressBookAdapter', 'updateEntry', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('OrganizationAddressBookAdapter', 'updateEntry', duration, error);
      console.error('Update address book entry error:', error);

      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }

      throw RepositoryError.queryFailed();
    }
  }

  async removeEntry(data: RemoveAddressBookEntryData): Promise<void> {
    const startTime = Date.now();
    const functionName = `${this.prefix}-removeAddressBookEntry`;
    this.logger.logRepositoryRequest('OrganizationAddressBookAdapter', 'removeEntry', { functionName, data });

    try {
      const fn = httpsCallable(functions, functionName);
      const result = await fn(data);

      if (!result.data || !(result.data as any).success) {
        throw RepositoryError.queryFailed();
      }

      const duration = Date.now() - startTime;
      this.logger.logRepositoryResponse('OrganizationAddressBookAdapter', 'removeEntry', duration, { success: true });
    } catch (error: any) {
      const duration = Date.now() - startTime;
      this.logger.logRepositoryError('OrganizationAddressBookAdapter', 'removeEntry', duration, error);
      console.error('Remove address book entry error:', error);

      if (error.details?.code) {
        throw new RepositoryError(error.details.code);
      }

      throw RepositoryError.queryFailed();
    }
  }
}
